import React, { useState } from 'react';

import Radio from '../Radio/Radio';

import classes from './Radios.module.scss';

const Radios = ({ className, options, value, onChange, type, name }) => {
  const [check, setCheck] = useState(value);

  const onChangeCheck = newValue => {
    setCheck(newValue);
    onChange(newValue);
  };

  const containerClasses = [classes.container];
  className && containerClasses.push(className);

  return (
    <div className={containerClasses.join(' ')}>
      {options.map(({ key, label }) => (
        <div key={key} className={classes.radio}>
          <Radio name={name} id={key} type={type} value={check} onChange={onChangeCheck} />
          <span className='medium-16'>{label}</span>
        </div>
      ))}
    </div>
  );
};

export default Radios;
